export default __webpack_public_path__ + "static/media/trainers.43e65730.svg";